module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "app-bar"
  }, [_c('div', {
    staticClass: "app-bar-wrapper"
  }, [_c('button', {
    class: [_vm.isBars ? _vm.barsClass : _vm.arrowClass],
    on: {
      "click": function($event) {
        _vm.sendMsg(_vm.show = !_vm.show)
      }
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isAdd),
      expression: "!isAdd"
    }],
    staticClass: "more",
    on: {
      "click": _vm.redirToAbout
    }
  }, [_c('i', {
    staticClass: "icon-info-circled"
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdd),
      expression: "isAdd"
    }],
    staticClass: "add",
    on: {
      "click": _vm.addTodo
    }
  }, [_vm._v("添加")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50cca722"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appBar.vue
// module id = 34
// module chunks = 0